import { ENVIRONMENTS } from "@/hooks/useEnvironment";
import { ProfessionalRole } from "@/network/useUser";

/**
 * Roles allowed to open the Admin panel in non-prod (local/dev/staging) —
 * broad, so anyone testing can use it. Prod is locked down to engineers only
 * (see {@link canAccessAdminPanel}). Editing this list is the single place to
 * grant/revoke non-prod access; future roles are excluded by default.
 */
export const ADMIN_PANEL_ROLES: ProfessionalRole[] = [
  ProfessionalRole.ENGINEER,
  ProfessionalRole.LOCAL,
  ProfessionalRole.NURSE_PRACTITIONER,
  ProfessionalRole.MEDICAL_ASSISTANT,
  ProfessionalRole.SUPPORT_AGENT,
  ProfessionalRole.FOP_COACH,
];

/** In prod, the panel is restricted to engineers. */
export const PROD_ADMIN_PANEL_ROLES: ProfessionalRole[] = [
  ProfessionalRole.ENGINEER,
];

// Fail-closed: only these envs get the broad allowlist. Anything else — prod,
// or an unknown/misconfigured FO_ENV — falls back to engineers only.
const NON_PROD_ENVIRONMENTS: string[] = [
  ENVIRONMENTS.LOCAL,
  ENVIRONMENTS.DEV,
  ENVIRONMENTS.STAGING,
];

export const canAccessAdminPanel = (role?: ProfessionalRole): boolean => {
  if (role === undefined) return false;
  const allowed = NON_PROD_ENVIRONMENTS.includes(import.meta.env.FO_ENV)
    ? ADMIN_PANEL_ROLES
    : PROD_ADMIN_PANEL_ROLES;
  return allowed.includes(role);
};
